import styled from 'styled-components';

export const ContentArea = styled.div`
  height: 100%;
  overflow: hidden auto;
  padding: 24px;
`;
